import React, {useEffect, useState} from 'react';
import '../Carta.css';
import iconoGenerico from '../iconoGenerico.svg';
import iconoFooter from '../logoFooter.svg';
import {
  AddAlt,
  LogoFacebook,
  LogoInstagram,
  LogoTwitter,
  Search,
  ShoppingCart,
  SubtractAlt,
  TrashCan
} from '@carbon/icons-react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { IoIosArrowDown, IoIosArrowBack } from "react-icons/io";
import { IoCall, IoLocationSharp } from "react-icons/io5";
import { AiFillInstagram } from "react-icons/ai";
import { FaSquareFacebook } from "react-icons/fa6";
import { IoChevronForwardSharp ,IoChevronBackSharp  } from "react-icons/io5";
import { useRef } from 'react';
import FlavorSelectionModal from '../components/flavors/FlavorSelectionModal';
import { requiresFlavorSelection, getMaxFlavors, getFlavorConfigText, prepareProductForCart, generateCartProductId } from '../utils/flavorUtils';

export default function Carta() {

  //flechas
  const categoriesRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const [selectedBranch, setSelectedBranch] = useState(null);
  const [showBranchSelector, setShowBranchSelector] = useState(true);
  const [subdomain, setSubdomain] = useState('');
  const [shopBranchs, setShopBranchs] = useState([]);
  const [branchConfig, setBranchConfig] = useState(null);
  const [showError, setShowError] = useState(false);
  const [branchFeatures, setBranchFeatures] = useState([]);

  const [showInfo, setShowInfo] = useState(false);

  const [categories, setCategories] = useState([]);

  const [instagram, setInstagram] = useState('');
  const [facebook, setFacebook] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const [imageSrc, setImageSrc] = useState('');
  const [colorshop, setColorShop] = useState('#000000');
  const [nameShopBranch, setNameShopBranch] = useState('');
  const [phoneShopBranch, setPhoneShopBranch] = useState('');
  const [address, setAddress] = useState('');
  const [longitude, setLongitude] = useState('');
  const [latitude, setLatitude] = useState('');
  const [nameCategorySelected, setNameCategorySelected] = useState('');

  const [productsForCategory, setProductsForCategory] = useState([]);

  const [searchProducts, setSearchProducts] = useState([]);
  const [searchCategoriesWithProducts, setSearchCategoriesWithProducts] = useState([]);
  const [searching, setSearching] = useState(false);

  const [allProducts, setAllProducts] = useState(true);
  const allProductsText = "TODOS LOS PRODUCTOS";

  const [dataProductsPedidoModal, setDataProductsPedidoModal] = useState([]);
  const [observationsPedido, setObservationsPedido] = useState('');

  // Estados para selección de gustos
  const [showFlavorModal, setShowFlavorModal] = useState(false);
  const [selectedProductForFlavors, setSelectedProductForFlavors] = useState(null);

  //datos de envio
  const [nameAndSuername, setNameAndSuername] = useState('');
  const [isDelivery, setIsDelivery] = useState(false);
  const [streetAddress, setStreetAddress] = useState('');
  const [numberAddress, setNumberAddress] = useState('');
  const [localidadDirection, setLocalidadDirection] = useState('');
  const [floorAddress, setFloorAddress] = useState('');
  const [deptoAddress, setDeptoAddress] = useState('');
  const [observationsAddress, setObservationsAddress] = useState('');
  const [imagesBanners, setImagesBanners] = useState([]);

  // Estados de validaciones activas/inactivas
  const [isAddressValid, setIsAddressValid] = useState(false);
  const [lastValidatedAddress, setLastValidatedAddress] = useState({});

  // chequea si tiene habilitada la feature de negocio GEOLOCALIZACION
  const googleLocalizationFeature = branchFeatures.find(
      (feature) => feature.name === 'GEOLOCALIZACION' && feature.status === true
  );
  const ruralSettingsFeatures = branchFeatures.find(feature => feature.name === 'ZONA RURAL');
  const [shippingPrice, setShippingPrice] = useState(0.0);
  // fin chequea si tiene habilitada la feature de negocio GEOLOCALIZACION

  const [isRuralDelivery, setIsRuralDelivery] = useState(false);

  const SendOrderType = {
    A_DOMICILIO: { label: "A domicilio", value: 1 },
    RETIRO_LOCAL: { label: "Retira en local", value: 2 }
  };

  const OrderType = {
    WHATSAP: { label: "WhatsApp", value: 1 },
    EN_MESA: { label: "En Mesa", value: 2 },
    DELIVERY: { label: "Delivery", value: 3 },
    A_DISTANCIA: { label: "A Distancia", value: 4 }
  };

  const validateAddress = async () => {
    if (!selectedBranch) return;

    const baseUrl = process.env.REACT_APP_API_LOCALIZATION_VALIDATE_ROUTE;

    const address = `${streetAddress} ${numberAddress}`;
    const encodedAddress = encodeURIComponent(address);
    const encodedLocality = encodeURIComponent(localidadDirection);
    if (streetAddress && numberAddress && localidadDirection) {
      try {
        const response = await fetch(`${baseUrl}${selectedBranch.id}?address=${encodedAddress}&locality=${encodedLocality}`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'X-Geolocation-Key': process.env.REACT_APP_API_KEY_GEOLOCATION,
          }
        });

        if (response.ok) {
          const data = await response.json();
          const { valid, message, shippingPrice, isOutOfRange } = data;

          if (valid === true) {
            showAlert({
              title: 'Dirección validada',
              text: `La dirección ha sido validada correctamente. Precio de envío: ${formatPrice(shippingPrice) || 'N/A'}`,
              icon: 'success'
            });
            setShippingPrice(shippingPrice);
            setIsAddressValid(true);
            setLastValidatedAddress({
              streetAddress,
              numberAddress,
              localidadDirection,
            });
          } else {
            showAlert({
              title: 'Error de validación:',
              text: message,
              icon: 'error'
            });
            setIsAddressValid(false);
            if (isOutOfRange) {
              showAlert({
                title: 'Error de validación:',
                text: message,
                icon: 'error'
              });
            }
          }
        }
      } catch (error) {
        showAlert({
          title: 'Error de conexión:',
          text: 'Hubo un problema al validar la dirección.',
          icon: 'error'
        });
        setIsAddressValid(false);
        throw error;
      }
    }
  };

  //el precio base de los delivery
  function getDeliveryPriceBase(config, isRuralDelivery) {
    // Verificar si la entrega es rural
    if (isRuralDelivery) {
      return config.priceRuralBase || 0;
    }

    // Si no es rural, revisa el tipo de entrega
    switch (config.deliveryType) {
      case 'COMMON':
        return config.deliveryCommon?.priceBase || 0;
      case 'CUSTOM':
        return shippingPrice;
      default:
        return 0;
    }
  }

  const toggleRuralDelivery = (isChecked) => {
    setIsRuralDelivery(isChecked);
    if (isChecked) {
      setShippingPrice(branchConfig.priceRuralBase);
      cleanErrorSendPedidoWithoutDeliveryReset();
    } else {
      const newPrice = formatPrice(getDeliveryPriceBase(branchConfig));
      setShippingPrice(newPrice);
    }
  };


  // Detecta si la dirección ha cambiado después de la validación
  const checkAddressChange = () => {
    const hasChanged =
        streetAddress !== lastValidatedAddress.streetAddress ||
        numberAddress !== lastValidatedAddress.numberAddress ||
        localidadDirection !== lastValidatedAddress.localidadDirection;

    if (hasChanged) {
      setIsAddressValid(false);
    }
  };

  const showAlert = ({ title, text, icon, confirmButton = true }) => {
    Swal.fire({
      title,
      text,
      icon,
      showConfirmButton: confirmButton,
      confirmButtonColor: colorshop,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
    });
  };

  const getAllCategories = (branch) => {
    if (!branch) return;

    axios.get(process.env.REACT_APP_API_CATEGORIES_PRODUCTS_ROUTE_CACHED, {
      params: {
        shopBranchId: branch.id
      }
    })
        .then(response => {
          console.log('Categorías cargadas:', response.data);
          setCategories(response.data);
          // Establecer "Todos los productos" como categoría inicial por defecto
          setNameCategorySelected(allProductsText);
          setAllProducts(true);
        })
        .catch(error => {
          console.error(error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudieron cargar las categorías',
          });
        });
  }

  const getRedes = (shopBranchId) => {
    if (!shopBranchId) return;

    axios.get(process.env.REACT_APP_API_SOCIALMEDIA_ROUTE, {
      params: {
        status: true,
        shopBranchId: shopBranchId
      }
    })
        .then(response => {
          getValueRedPhoneNumber(response.data);
          getValueRedInstagram(response.data);
          getValueRedFacebook(response.data);
        })
        .catch(error => {
          console.error(error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudieron cargar las redes sociales',
          });
        });
  }

  const getAllImagesBanners = (shopBranchId) => {
    axios.get(process.env.REACT_APP_API_BANNER_IMAGES_GET_ROUTE + "/" + shopBranchId, {
    })
        .then(response => {
          setImagesBanners(response.data);
        })
        .catch(error => {
          console.error(error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudieron cargar los banners',
          });
        });
  }

  const getLogoImage = (shopBranchId) => {
    axios.get(process.env.REACT_APP_API_SHOP_ROUTE_UPDATE_LOGO_IMAGE + "/" + shopBranchId, {
      responseType: "blob",
    })
        .then((response) => {
          if(response.data.size !== 0){
            const imageBlob = response.data;
            const imageURL = URL.createObjectURL(imageBlob);
            setImageSrc(imageURL);
          }
        })
        .catch(() => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error cargando la imagen del logo',
          })
        })
  }

  const getCategoryColor = (shopBranchId) => {
    if (!shopBranchId) return;

    axios.get(process.env.REACT_APP_API_SHOP_ROUTE_UPDATE_CATEGORY_COLOR + "/" + shopBranchId)
        .then((response) => {
          setColorShop(response.data);
        })
        .catch((error) => {
          console.error(error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo cargar el color de la categoría',
          });
        });
  }

  const getShopBranches = (subdomain) => {
    axios.get(process.env.REACT_APP_API_SHOP_SUBDOMAIN_ROUTE, {
      params: {
        subdomain: subdomain
      }
    })
        .then(response => {
          const shopBranchsData = response.data;
          if (shopBranchsData && shopBranchsData.length > 0) {
            setShopBranchs(shopBranchsData);
            setShowError(false);
            
            // Si hay una sola sucursal, seleccionarla automáticamente
            if (shopBranchsData.length === 1) {
              handleBranchSelection(shopBranchsData[0]);
            }
          } else {
            setShowError(true);
          }
        })
        .catch(error => {
          console.error(error);
          setShowError(true);
        });
  }

  const getBranchConfig = async (shopBranchId) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_MODULES_CONFIGS_CARTA_ROUTE, {
        params: {
          shopBranchId: shopBranchId
        }
      });
      if (response.data) {
        setBranchConfig(response.data);
      }
    } catch (error) {
      console.error('Error al obtener la configuración de la sucursal:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo cargar la configuración de la sucursal',
      });
    }
  };

  const getBranchFeatures = async (shopBranchId) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_FEATURE_SELECTOR_CARTA_ROUTE, {
        params: {
          shopBranchId: shopBranchId
        }
      });
      if (response.data) {
        setBranchFeatures(response.data);
      }
    } catch (error) {
      console.error('Error al obtener las features de la sucursal:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudieron cargar las características de la sucursal',
      });
    }
  };

  const handleBranchSelection = (branch) => {
    setSelectedBranch(branch);
    setShowBranchSelector(false);
    
    // Resetear estados relacionados con categorías y productos
    setCategories([]);
    setProductsForCategory([]);
    setNameCategorySelected('');
    setAllProducts(true);
    
    // Obtener la configuración y features específicas de la sucursal
    getBranchConfig(branch.id);
    getBranchFeatures(branch.id);
    // Aquí puedes iniciar la carga de datos específicos de la sucursal
    getAllCategories(branch);

    setNameShopBranch(branch.name);
    setPhoneShopBranch(branch.phoneNumber);
    setAddress(branch.address);
    setLongitude(branch.longitude);
    setLatitude(branch.latitude);

    getCategoryColor(branch.id);
    getRedes(branch.id);
    getAllImagesBanners(branch.id);
    getLogoImage(branch.id);
  }

  const isDevDemoProd = (subdomain) => {
    return ['-dev', '-demo', '-qreate'].some(suffix => subdomain.endsWith(suffix));
  };

  //flechas
  const checkScroll = () => {
    const container = categoriesRef.current;
    if (!container) return;

    const { scrollLeft, scrollWidth, clientWidth } = container;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
  };

  useEffect(() => {
    document.title = 'CARTA';

    const hostname = window.location.hostname; // ej. "celumania.localhost" o "local1-demo.ucoode.com.ar"
    const firstPart = hostname.split('.')[0];  // ej. "celumania" o "local1-demo"

    let subdomain;

    if (hostname.includes('localhost')) {
      // En local, tomar todo lo que está antes del primer punto
      subdomain = firstPart;
    } else if (isDevDemoProd(firstPart)) {
      // En dev, demo o prod: tomar lo que está antes del primer guion "-"
      subdomain = firstPart.split('-')[0];
    } else {
      // Caso general (sin sufijo especial), tomar todo lo que está antes del primer punto
      subdomain = firstPart;
    }

    setSubdomain(subdomain);
    getShopBranches(subdomain);

    // Inicializar el carrito para todas las sucursales
    shopBranchs.forEach(branch => {
      const storageKey = getStorageKey(branch.id);
      if(!localStorage.getItem(storageKey)) {
        const listadoVacio = [];
        saveCartProducts(listadoVacio);
      }
    });
  }, []);

  useEffect(() => {
    const container = categoriesRef.current;
    if (!container) return;

    checkScroll();
    container.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);

    return () => {
      container.removeEventListener('scroll', checkScroll);
      window.removeEventListener('resize', checkScroll);
    };
  }, []);

  // Actualizar flechas cuando cambien las categorías
  useEffect(() => {
    setTimeout(checkScroll, 100);
  }, [categories]);

  const scrollCategories = (direction) => {
    const container = categoriesRef.current;
    if (!container) return;
    const scrollAmount = direction === 'left' ? -300 : 300;
    container.scrollBy({
      left: scrollAmount,
      behavior: 'smooth',
    });
    setTimeout(checkScroll, 300);// Le damos un pequeño delay para que scrollBy se ejecute y luego chequeamos
  };

  const getValueRedInstagram = (redes) => {
    let instagram = redes && redes.find(red => red.socialMediaType === "INSTAGRAM");
    if(instagram != null){
      setInstagram(instagram.socialMediaLink);
    }
  }

  const getValueRedFacebook = (redes) =>{
    let facebook = redes && redes.find(red => red.socialMediaType === "FACEBOOK");
    if(facebook != null){
      setFacebook(facebook.socialMediaLink);
    }
  }

  const getValueRedPhoneNumber = (redes) =>{
    let phoneNumber = redes && redes.find(red => red.socialMediaType === "PHONENUMBER");
    if(phoneNumber != null){
      setPhoneNumber(phoneNumber.socialMediaLink);
    }
  }

  const fillProductsByIdCategorySelected = (idCategory) => {
    setProductsForCategory([]);  // Inicializar con array vacío
    document.getElementById('nameProdSearch').value = "";
    search('');
    const categoria = categories.find(categoria => categoria.id === idCategory);
    setProductsForCategory(categoria ? categoria.productDTOList : []);
  }

  const fillAllProducts = () => {
    setProductsForCategory([]);  // Inicializar con array vacío
    document.getElementById('nameProdSearch').value = "";
    search('');
  }

  const search = (nameProd) => {
    if(nameProd != ''){
      setSearching(true);
      if(allProducts){
        setSearchCategoriesWithProducts(filterCategorieByProduct(nameProd));
      } else {
        const productsFilters = productsForCategory.filter(product =>
            product.name.toLowerCase().includes(nameProd.toLowerCase()));
        setSearchProducts(productsFilters);
      }
    }else{
      setSearching(false);
      setSearchProducts('');
      setSearchCategoriesWithProducts('');
    }
  }

  const filterCategorieByProduct = (texto) => {
    const filteredCategories = [];

    categories.forEach(categoria => {
      const filteredProducts = categoria.productDTOList.filter(producto => {
        return producto.name.toLowerCase().includes(texto.toLowerCase());
      });

      if (filteredProducts.length > 0) {
        const filteredCategorie = {
          ...categoria,
          productDTOList: filteredProducts
        };
        filteredCategories.push(filteredCategorie);
      }
    });

    return filteredCategories;
  }

  function formatPrice(price) {
    if (price == null || isNaN(price)) return '';
    return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(price);
  }

  // Función para obtener la clave del localStorage específica para la sucursal
  const getStorageKey = (branchId) => {
    return `productsPedido_${branchId}`;
  };

  // Función para obtener los productos del carrito
  const getCartProducts = () => {
    if (!selectedBranch) return [];
    const storageKey = getStorageKey(selectedBranch.id);
    const products = localStorage.getItem(storageKey);
    return products ? JSON.parse(products) : [];
  };

  // Función para guardar los productos en el carrito
  const saveCartProducts = (products) => {
    if (!selectedBranch) return;
    const storageKey = getStorageKey(selectedBranch.id);
    localStorage.setItem(storageKey, JSON.stringify(products));
  };

  const addProdPedido = (newProd) => {
    if (!selectedBranch) return;
    
    // Verificar si el producto requiere selección de gustos
    if (requiresFlavorSelection(newProd)) {
      console.log('=== DEBUG CARTA - ABRIENDO MODAL DE GUSTOS ===');
      console.log('Producto seleccionado:', newProd);
      console.log('selectedBranch:', selectedBranch);
      console.log('selectedBranch.id:', selectedBranch?.id);
      console.log('requiresFlavorSelection:', requiresFlavorSelection(newProd));
      
      setSelectedProductForFlavors(newProd);
      setShowFlavorModal(true);
      return;
    }
    
    // Para productos sin gustos, proceder normalmente
    addProductToCart(newProd);
  }

  const addProductToCart = (product) => {
    if (!selectedBranch) return;
    
    let productsPedido = getCartProducts();
    const cartProduct = prepareProductForCart(product);
    
    // Buscar si ya existe el producto (considerando gustos)
    const existingIndex = productsPedido.findIndex(p => p.id === cartProduct.id);
    
    if (existingIndex === -1) {
      // Producto no existe, agregarlo
      productsPedido.push(cartProduct);
    } else {
      // Producto existe, incrementar cantidad
      productsPedido[existingIndex].cant += 1;
    }
    
    saveCartProducts(productsPedido);
    setDataProductsPedidoModal(productsPedido);

    const cantEnPedidoElement = document.getElementById('cantEnPedido');
    if (cantEnPedidoElement) {
      cantEnPedidoElement.value = parseInt(cantEnPedidoElement.value || 0) + 1;
    } else {
      console.warn("Element with ID 'cantEnPedido' not found.");
    }
  }

  const handleFlavorConfirm = (productWithFlavors) => {
    addProductToCart(productWithFlavors);
  }

  // Función específica para incrementar cantidad desde el carrito
  // No verifica si requiere gustos porque el producto ya está en carrito
  const increaseProductQuantity = (productFromCart) => {
    if (!selectedBranch) return;
    
    let productsPedido = getCartProducts();
    
    // Buscar el producto por ID
    const existingIndex = productsPedido.findIndex(p => p.id === productFromCart.id);
    
    if (existingIndex !== -1) {
      // Incrementar cantidad directamente
      productsPedido[existingIndex].cant += 1;
      
      saveCartProducts(productsPedido);
      setDataProductsPedidoModal(productsPedido);

      const cantEnPedidoElement = document.getElementById('cantEnPedido');
      if (cantEnPedidoElement) {
        cantEnPedidoElement.value = parseInt(cantEnPedidoElement.value || 0) + 1;
      }
    }
  }

  const minusProdPedido = (idProduct) => {
    if (!selectedBranch) return;
    let productsPedido = getCartProducts();
    
    // Buscar todas las variantes del producto (incluyendo versiones con gustos)
    const productVariants = productsPedido.filter(p => 
      p.originalId === idProduct || p.id === idProduct
    );
    
    if (productVariants.length > 0) {
      // Tomar la última variante agregada (la más reciente)
      const lastVariant = productVariants[productVariants.length - 1];
      const variantIndex = productsPedido.findIndex(p => p.id === lastVariant.id);
      
      if (productsPedido[variantIndex].cant > 1) {
        productsPedido[variantIndex].cant -= 1;
      } else {
        productsPedido = productsPedido.filter(producto => producto.id !== lastVariant.id);
      }
      
      saveCartProducts(productsPedido);
      setDataProductsPedidoModal(productsPedido);
      document.getElementById('cantEnPedido').value = document.getElementById('cantEnPedido').value - 1;
    }
  }

  const deleteProductPedido = (idProduct) => {
    if (!selectedBranch) return;
    let productsPedido = getCartProducts();
    productsPedido = productsPedido.filter(producto => producto.id !== idProduct);
    saveCartProducts(productsPedido);
    setDataProductsPedidoModal(productsPedido);
  }

  const contProd = (idProduct) => {
    if (!selectedBranch) return "0";
    const productsPedido = getCartProducts();
    if(productsPedido != null){
      // Para productos con gustos, contar todas las variantes del producto original
      const productCount = productsPedido.reduce((total, cartProduct) => {
        if (cartProduct.originalId === idProduct || cartProduct.id === idProduct) {
          return total + cartProduct.cant;
        }
        return total;
      }, 0);
      return productCount.toString();
    }
    return "0";
  }

  const calcularTotal = (productos) => {
    let total = 0;

    for (let i = 0; i < productos.length; i++) {
      const producto = productos[i];
      const subtotal = producto.price * producto.cant;
      total += subtotal;
    }

    return total;
  }

  const cleanPedidoBorrador = () => {
    Swal.fire({
      title: '¿Estás seguro de borrar el pedido?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Borrar',
      confirmButtonColor: colorshop,
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        cleanPedido();
      } else {
        const botonCarrito = document.getElementById('btnCarrito');
        botonCarrito.click();
      }
    });
  }

  const cleanPedido = () => {
    if (!selectedBranch) return;
    const storageKey = getStorageKey(selectedBranch.id);
    document.getElementById('cantEnPedido').value = "0";
    const listadoVacio = [];
    saveCartProducts(listadoVacio);
    window.location.reload();
  }

  // Función reutilizable para mostrar errores de campo
  const showFieldError = (selectorError, selectorInput) => {
    const fieldRequiredElement = document.querySelector(selectorError);
    const inputElement = document.getElementById(selectorInput);
    if (fieldRequiredElement && inputElement) {
      fieldRequiredElement.style.display = 'block';
      inputElement.style.border = '1px solid #ff1717';
    }
  };

  const sendOrderForWhatsapp = () => {
    const isNameInvalid = !nameAndSuername?.trim();

    const isDeliveryInvalid = isDelivery && !isRuralDelivery && (
        !streetAddress?.trim() ||
        !numberAddress?.trim() ||
        !localidadDirection?.trim()
    );

    if (isNameInvalid || isDeliveryInvalid) {
      if (isNameInvalid) {
        showFieldError('.errorNameAndSurname', 'nameAndSurname');
      }

      if (isDelivery && !isRuralDelivery) {
        if (!streetAddress?.trim()) {
          showFieldError('.errorStreetAddress', 'streetAddress');
        }
        if (!numberAddress?.trim()) {
          showFieldError('.errorNumberAddress', 'numberAddress');
        }
        if (!localidadDirection?.trim()) {
          showFieldError('.errorLocalidadDirection', 'localidadDirection');
        }
      }
      return;
    }

    if (isDelivery && !isRuralDelivery && branchConfig?.verifyAddress && !isAddressValid) {
      showAlert({
        title: 'Error de dirección',
        text: 'La dirección ha cambiado o no ha sido validada. Por favor, validá la dirección antes de continuar.',
        icon: 'error',
      });
      return;
    }

    confirmarEnvioPedido();
  };


  const confirmarEnvioPedido = () => {
    Swal.fire({
      title: '¿Enviar pedido?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      confirmButtonColor: colorshop,
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        if (!branchConfig?.status) {
          Swal.fire({
            title: 'Por el momento ya no tomamos más pedidos',
            text: "Gracias por tu comprensión, ¡te esperamos la próxima!",
            icon: 'error',
            showConfirmButton: true,
            allowOutsideClick: false,
            confirmButtonColor: colorshop,
            allowEscapeKey: false,
            allowEnterKey: false,
          }).then((result) => {
            if (result.isConfirmed) {
              const btnCloseModalCarrito = document.getElementById('btnCloseCarrito');
              btnCloseModalCarrito.click();
              const btnCloseModalDatosPersona = document.getElementById('btnCloseModalPersona');
              btnCloseModalDatosPersona.click();
            }
          });
        } else {
          let orderNumber = Date.now();
          sendOrder(orderNumber)
              .then(() => {
                // Llamamos a WhatsApp solo si sendOrder fue exitoso y si esta activa la notificacion por wpp
                if(branchConfig.messageWppActive){
                  createAndSendMessagePedidoWhatsapp(orderNumber);
                }else{
                  Swal.fire({
                    icon: 'success',
                    title: '¡Creado!',
                    html: `
                          <p>El pedido fue enviado con éxito. <br> 
                          <strong>Nro de pedido:</strong> <span id="orderNumber">${orderNumber}</span></p>
                          <p style="color: "#7c7c7c"; font-weight: 500;">⚠ No olvides guardar tu número de pedido.</p>
                          <button id="copyBtn" style="padding: 5px 10px; border-radius: 5px; cursor: pointer;">
                            Copiar número
                          </button>
                        `,
                    showConfirmButton: true,
                    confirmButtonText: 'OK',
                    didOpen: () => {
                      const copyBtn = Swal.getPopup().querySelector("#copyBtn");
                      copyBtn.addEventListener("click", (event) => {
                        event.stopPropagation(); // Evita que el Swal se cierre

                        const orderText = document.getElementById("orderNumber").innerText;
                        navigator.clipboard.writeText(orderText).then(() => {
                          copyBtn.style.backgroundColor = "#28a745";
                          copyBtn.style.color = "white";
                          copyBtn.innerText = "Copiado ✔";
                          copyBtn.disabled = true;
                        });
                      });
                    }
                  }).then(() => {
                    cleanPedido();
                  });
                }
              })
              .catch((error) => {
                console.log("Error al enviar el pedido:", error);
              });
        }
      }
    });
  };

  function isDeliveryActive(config) {
    if (!config) return false;

    if (config.idDelivery !== null && config.deliveryType !== "NO_DELIVERIES") {
      return config.deliveryType === 'COMMON'
          ? config.deliveryCommon?.active || false
          : config.deliveryType === 'CUSTOM'
              ? config.deliveryCustom?.active || false
              : false;
    }
    return false;
  }


  const sendOrder = (orderNumber) => {
    return new Promise((resolve, reject) => {
      let order = {
        id: null,
        orderNumber: orderNumber,
        ownerOrder: nameAndSuername,
        totalAmount: 0,
        tableId: 1, //setear numero de mesa que selecciono el usuario
        orderType: OrderType.WHATSAP.value,
        sendOrderType: (isDelivery && isDeliveryActive(branchConfig)) ? SendOrderType.A_DOMICILIO.value : SendOrderType.RETIRO_LOCAL.value,
        address: streetAddress,
        numberAdress: numberAddress,
        floor: floorAddress,
        department: deptoAddress,
        provinceId: 20, //ver como mando el id de la provincia
        orderDetails: [],
        orderObservation: observationsPedido,
        deliveryObservation: observationsAddress,
        shippingPrice: getDeliveryPriceBase(branchConfig),
        ruralDeliveryActive: isRuralDelivery,
        shopBranchId: selectedBranch.id // Agregamos el ID de la sucursal seleccionada
      };

      let products = getCartProducts();
      products.forEach((product) => {
        order.totalAmount += (product.cant * product.price);
        order.orderDetails.push(createOrderDetail(product));
      });

      order.totalAmount = order.totalAmount.toFixed(2);

      axios.post(process.env.REACT_APP_API_ORDER_CARTA_ROUTE, order, {
        params: {
          shopBranchId: selectedBranch.id
        }
      })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            const errorMessage = error.response?.data.message || 'Ocurrió un error inesperado';
            Swal.fire({
              title: 'Error con el pedido:',
              text: errorMessage,
              icon: 'error',
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false
            });
            reject(error);
          });
    });
  };

  const createOrderDetail = (product) => {
    // Usar originalId si existe (para productos con gustos), sino usar id normal
    const realProductId = product.originalId || product.id;
    
    // Preparar selectedFlavorIds
    let selectedFlavorIds = null;
    if (product.selectedFlavors && product.selectedFlavors.length > 0) {
      selectedFlavorIds = product.selectedFlavors.map(flavor => flavor.id);
    }
    
    // Convertir price a número de forma segura
    const price = Number(product.price) || 0;
    const quantity = Number(product.cant) || 1;
    
    const orderDetail = {
      id: null,
      orderId: null,
      productId: realProductId,               // ✅ Solo el ID numérico del producto
      productName: product.name,
      brandName: product.brandName,
      quantity: quantity,                     // ✅ Long (number)
      unitaryPrice: price.toFixed(2),         // ✅ String con decimales
      subTotal: (quantity * price).toFixed(2) // ✅ String con decimales
    };
    
    // Solo agregar selectedFlavorIds si hay gustos seleccionados
    if (selectedFlavorIds && selectedFlavorIds.length > 0) {
      orderDetail.selectedFlavorIds = selectedFlavorIds; // ✅ Array de IDs de gustos
    }
    
    return orderDetail;
  }

  const createAndSendMessagePedidoWhatsapp = (orderNumber) => {
    let totalPedido = 0;
    let mensaje = 'Hola ' + nameShopBranch + ", quiero hacerte un pedido a nombre de " + nameAndSuername.trim() + ":";

    let products = getCartProducts();

    mensaje = mensaje + `\n`;
    mensaje = mensaje + `\n`;

    let productosTexto = "";

    products.forEach((product) => {
      productosTexto += `${product.cant}X ${product.name} ${formatPrice(product.price)}\n`;
      totalPedido += (product.price * product.cant);
    });

    if (isDelivery && isDeliveryActive(branchConfig)) {
      let priceEnvio = formatPrice(getDeliveryPriceBase(branchConfig));
      productosTexto += `ENVÍO ${formatPrice(priceEnvio)}\n`;
      totalPedido += parseFloat(priceEnvio);
    }
    mensaje += "Número de pedido: " + orderNumber;

    mensaje = mensaje + `\n`;
    mensaje = mensaje + `\n`;

    mensaje += `\Detalle del pedido:\n${productosTexto}`;

    mensaje = mensaje + `\n`;

    if (observationsPedido != null && observationsPedido != '') {
      mensaje = mensaje + "Observaciones del pedido: " + observationsPedido + ".";
      mensaje = mensaje + `\n`;
      mensaje = mensaje + `\n`;
    }

    mensaje = mensaje + "TOTAL: " + formatPrice(totalPedido);

    mensaje = mensaje + `\n`;
    mensaje = mensaje + `\n`;

    if(isDelivery && isDeliveryActive(branchConfig)){
      mensaje = mensaje + "Pedido con envio, al siguiente domicilio: " + streetAddress + " " + numberAddress + ".";
      if(floorAddress != '' && floorAddress != null){
        mensaje = mensaje + `\n`;
        mensaje = mensaje + "Piso: " + floorAddress + ".";
      }
      if(deptoAddress != '' && deptoAddress != null){
        mensaje = mensaje + `\n`;
        mensaje = mensaje + "Departamento: " + deptoAddress + ".";
      }
      if (observationsAddress != null && observationsAddress != '') {
        mensaje = mensaje + `\n`;
        mensaje = mensaje + "Observaciones de envío: " + observationsAddress + ".";
      }
    }else{
      mensaje = mensaje + "Retiro el pedido por el local.";
    }

    mensaje = mensaje + `\n`;
    mensaje = mensaje + `\n`;

    mensaje = mensaje + "¡Muchas gracias!"

    // Limpiamos el número de teléfono
    let numero = phoneShopBranch.replace(/\D/g, ''); // Elimina caracteres no numéricos
    if (numero.startsWith('0')) {
      numero = numero.substring(1); // Elimina el 0 inicial si existe
    }
    if (!numero.startsWith('54')) {
      numero = '54' + numero; // Agrega el código de país si no existe
    }

    // Intentamos primero con web.whatsapp.com
    try {
      const url = `https://web.whatsapp.com/send?phone=${numero}&text=${encodeURIComponent(mensaje)}`;
      window.open(url, '_blank');
    } catch (error) {
      // Si falla, intentamos con wa.me
      const fallbackUrl = `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;
      window.open(fallbackUrl, '_blank');
    }

    cleanPedido();
  }


  const cleanErrorField = (inputId, errorClass) => {
    const inputElement = document.getElementById(inputId);
    const fieldRequiredElement = document.querySelector(`.${errorClass}`);

    if (inputElement?.value) {
      fieldRequiredElement.style.display = 'none';
      inputElement.style.border = '';
    }
  };

  const cleanError = () => {
    const errorElements = [
      { error: '.errorStreetAddress', input: 'streetAddress' },
      { error: '.errorNumberAddress', input: 'numberAddress' },
      { error: '.errorLocalidadDirection', input: 'localidadDirection' }
    ];

    errorElements.forEach(({ error, input }) => {
      const fieldRequiredElement = document.querySelector(error);
      const inputElement = document.getElementById(input);

      if (fieldRequiredElement) fieldRequiredElement.style.display = 'none';
      if (inputElement) inputElement.style.border = '1px solid #ced4da';
    });
  };

  const cleanErrorSendPedidoWithoutDeliveryReset = () => {
    cleanError();
    setStreetAddress('');
    setNumberAddress('');
    setLocalidadDirection('');
    setFloorAddress('');
    setDeptoAddress('');
    setObservationsAddress('');
  };


  const cleanErrorSendPedido = () => {
    let fieldRequiredElement = document.querySelector('.errorNameAndSurname');
    if (fieldRequiredElement) {
      fieldRequiredElement.style.display = 'none';
    }

    let inputElement = document.getElementById('nameAndSurname');
    if (inputElement) {
      inputElement.style.border = '';
    }

    setNameAndSuername('');

    if (isDelivery) {
      fieldRequiredElement = document.querySelector('.errorAddressPedido');
      if (fieldRequiredElement) {
        fieldRequiredElement.style.display = 'none';
      }

      inputElement = document.getElementById('addressPedido');
      if (inputElement) {
        inputElement.style.border = '';
      }
    }
    setNumberAddress('');
    setLocalidadDirection('');
    setFloorAddress('');
    setDeptoAddress('');
    setObservationsAddress('')
    setIsDelivery(false);
  }

  // Función para verificar si una feature específica está activa
  const isFeatureActive = (featureName) => {
    const feature = branchFeatures.find(
        (feature) => feature.name === featureName && feature.status === true
    );
    return !!feature;
  };

  const handleBackToBranchSelector = () => {
    setShowBranchSelector(true);
    setSelectedBranch(null);
    setBranchConfig(null);
    setBranchFeatures([]);
    setImageSrc('');
    setImagesBanners([]);
    setCategories([]);
    setNameShopBranch('');
    setPhoneShopBranch('');
    setAddress('');
    setLongitude('');
    setLatitude('');
    setInstagram('');
    setFacebook('');
    setPhoneNumber('');
    setColorShop('#000000');
    setProductsForCategory([]);
    setNameCategorySelected('');
    setSearchProducts([]);
    setSearchCategoriesWithProducts([]);
    setSearching(false);
    setAllProducts(true);
    setDataProductsPedidoModal([]);
    setObservationsPedido('');
    setIsDelivery(false);
    setStreetAddress('');
    setNumberAddress('');
    setLocalidadDirection('');
    setFloorAddress('');
    setDeptoAddress('');
    setObservationsAddress('');
    setIsAddressValid(false);
    setLastValidatedAddress({});
    setShippingPrice(0.0);
    setIsRuralDelivery(false);
  };

  return (
      <div className="notranslate" translate="no">
        {showError ? (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '100vh',
              padding: '20px',
              backgroundColor: '#f5f5f5',
              textAlign: 'center'
            }}>
              <h2 style={{
                fontSize: '24px',
                marginBottom: '20px',
                color: '#333'
              }}>URL no encontrada</h2>
              <p style={{
                fontSize: '16px',
                color: '#666',
                marginBottom: '30px'
              }}>Lo sentimos, la URL que estás intentando acceder no existe o no está disponible.</p>
              <div style={{
                display: 'flex',
                gap: '20px'
              }}>
              </div>
            </div>
        ) : showBranchSelector ? (
            <div className="branch-selector" style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '100vh',
              padding: '20px',
              backgroundColor: '#f5f5f5'
            }}>
              <h2 style={{
                fontSize: '24px',
                marginBottom: '30px',
                color: '#333',
                textAlign: 'center'
              }}>Selecciona una sucursal</h2>
              <div className="branch-list" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '20px',
                width: '100%',
                maxWidth: '1200px'
              }}>
                {shopBranchs.map((branch) => (
                    <div key={branch.id}
                         className="branch-card"
                         onClick={() => handleBranchSelection(branch)}
                         style={{
                           backgroundColor: 'white',
                           borderRadius: '10px',
                           padding: '20px',
                           boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                           cursor: 'pointer',
                           transition: 'transform 0.2s, box-shadow 0.2s',
                           ':hover': {
                             transform: 'translateY(-5px)',
                             boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                           }
                         }}>
                      <h3 style={{
                        fontSize: '20px',
                        marginBottom: '15px',
                        color: '#333'
                      }}>{branch.name}</h3>
                      <p style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginBottom: '10px',
                        color: '#666'
                      }}><IoLocationSharp size={15}/> {branch.address}</p>
                      <p style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginBottom: '10px',
                        color: '#666'
                      }}><IoCall size={15}/> {branch.phoneNumber}</p>
                      <p style={{
                        color: '#666',
                        marginBottom: '0'
                      }}>{branch.city}</p>
                    </div>
                ))}
              </div>
            </div>
        ) : (
            <div className="carta-body">
              {(!branchConfig?.status &&
                  <div className="aviso">
                    <p>Por el momento no se toman pedidos.</p>
                  </div>
              )}
              {shopBranchs.length > 1 && (
                <div style={{
                  position: 'fixed',
                  top: '20px',
                  left: '20px',
                  zIndex: 1000,
                  cursor: 'pointer',
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  transition: 'transform 0.2s',
                  ':hover': {
                    transform: 'scale(1.1)'
                  }
                }} onClick={handleBackToBranchSelector}>
                  <IoIosArrowBack size={24} color={colorshop} />
                </div>
              )}

              <div className="banner-wrapper" style={{background: colorshop}}>
                <div className="banner" style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                  {imageSrc != null && imageSrc != '' ? (
                      <img src={imageSrc} alt="QReate" className='imgCartaBanner'/>
                  ) : (
                      <h1 className='nameShopCarta'>{nameShopBranch}</h1>
                  )}
                </div>
              </div>
              {(
                  (latitude != null && latitude !== '' && longitude != null && longitude !== '') ||
                  (phoneNumber != null && phoneNumber !== '') ||
                  (instagram != null && instagram !== '') ||
                  (facebook != null && facebook !== '')
              ) && (
                  <div className="text-center">
                    <button className="btnVerMas" onClick={() => setShowInfo(!showInfo)} style={{ color: 'gray' }}>
                      Ver más
                    </button>
                    <div className={`flecha-abajo ${showInfo ? "rotar" : ""}`}>
                      <IoIosArrowDown size={24} color="gray" onClick={() => setShowInfo(!showInfo)} />
                    </div>
                  </div>
              )}

              <div className={`info-local ${showInfo ? "mostrar" : ""}`}>
                <h5 className="mb-3" style={{fontWeight: 'bold'}}>{nameShopBranch}</h5>
                {latitude != null && latitude != '' && longitude != null && longitude != '' &&
                    <p><IoLocationSharp size={25}/>
                      <a href={`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}
                         target="_blank"
                         rel="noopener noreferrer"
                         className="link-custom"
                         style={{marginLeft: '2px'}}>
                        {address}
                      </a>
                    </p>
                }

                {phoneNumber != null && phoneNumber != '' &&
                    <p><IoCall className='icono-redes'/>
                      <a href={`tel:${phoneNumber}`} className="link-custom" style={{marginLeft: '2px'}}>
                        {phoneNumber}
                      </a>
                    </p>
                }

                {instagram != null && instagram != '' &&
                    <p><AiFillInstagram   className='icono-redes'/>
                      <a href={`https://www.instagram.com/${instagram}`}
                         target="_blank"
                         className="link-custom"
                         rel="noopener noreferrer" style={{marginLeft: '2px'}}>
                        @{instagram}
                      </a>
                    </p>
                }

                {facebook != null && facebook != '' &&
                    <p><FaSquareFacebook className='icono-redes'/>
                      <a href={`https://www.facebook.com/${facebook}`}
                         target="_blank"
                         className="link-custom"
                         rel="noopener noreferrer" style={{marginLeft: '2px'}}>
                        {facebook}
                      </a>
                    </p>
                }
                
                {/* Botón Ver Mi Pedido dentro del contenido desplegable */}
                <div className="containerBtnMiPedido" style={{
                  marginTop: '20px',
                  textAlign: 'center'
                }}>
                  <Link
                      to="/estadoDelPedido"
                      state={{shopBranch: selectedBranch}}
                      className="btn miPedidoButton"
                      style={{
                        backgroundColor: colorshop,
                        color: '#ffffff',
                        padding: '12px 24px',
                        borderRadius: '8px',
                        textDecoration: 'none',
                        display: 'inline-block',
                        fontWeight: 'bold',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        whiteSpace: 'nowrap',
                        minWidth: '160px'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
                      }}
                  >
                    Ver Mi Pedido
                  </Link>
                </div>
              </div>

              {imagesBanners.filter(b => b.urlImage).length > 0 && (
                  <div className="carrouselContainer">
                    <Carousel
                        className="carrouselCarta"
                        interval={3000}
                        controls={false}
                        indicators={true}
                        pause="hover"
                        wrap={true}
                    >
                      {imagesBanners.map((banner, index) => (
                          banner.urlImage ? (
                              <Carousel.Item  className="carrousel-item" key={index}>
                                <img
                                    className="carrousel-img"
                                    src={banner.urlImage}
                                    alt={`Banner ${banner.id}`}
                                />
                              </Carousel.Item>
                          ) : null
                      ))}
                    </Carousel>
                  </div>
              )}

                <div className="categories-outer-container">
                  {canScrollLeft && (
                      <button className="arrow left-arrow" onClick={() => scrollCategories("left")}><IoChevronBackSharp /></button>
                  )}
                  <div className="categories-inner-container" ref={categoriesRef} >
                    <div className="categories">
                      <div className="category" style={{marginLeft: '1%'}}>
                        <button className={`round-button ${allProducts === true ? 'selectedCategory' : ''}`}
                                onClick={() => {
                                  console.log('Click en "Todos los productos"');
                                  fillAllProducts();
                                  setAllProducts(true);
                                  setNameCategorySelected(allProductsText);
                                }} style={{backgroundColor: colorshop}}>
                          <img src={iconoGenerico} alt="Icono" className='iconCategory'/>
                        </button>
                        <div className="category-name-carta">{allProductsText}</div>
                      </div>
                      {
                        categories.map((category, index) => (
                            <div className="category" key={index} style={{ animationDelay: `${(index + 1) * 0.1}s` }} >
                              <div className="category-inner">
                                <button
                                    className={`round-button ${(category.name === nameCategorySelected && !allProducts) ? 'selectedCategory' : ''}`}
                                    onClick={() => {
                                      console.log('Click en categoría:', category.name);
                                      fillProductsByIdCategorySelected(category.id);
                                      setNameCategorySelected(category.name);
                                      setAllProducts(false)
                                    }} style={{backgroundColor: colorshop}}>
                                  <img src={category.urlIcon} alt="Icono" className='iconCategory'/>
                                </button>
                              </div>
                              <div className="category-name-carta">{category.name}</div>
                            </div>
                        ))
                      }
                    </div>
                  </div>
                  {canScrollRight && (
                      <button className="arrow right-arrow" onClick={() => scrollCategories("right")}><IoChevronForwardSharp /></button>
                  )}
                </div>

              <div className='ms-3 me-3'>
                <div className="searchProduct">
                  <div className="search">
                    <input type="text" id='nameProdSearch' className="searchProdCarta" placeholder="Buscar producto"
                           style={{width: "100%"}} onChange={(e) => search(e.target.value)}/>
                    <Search className="btnSearchCarta" size="35"/>
                  </div>
                </div>

                <div className="mt-4 mb-4 products" style={{minHeight: '40vh'}}>
                  {allProducts ? (
                      (searching) ? (
                          <>
                            <h6 className='allProductsText'>{allProductsText}</h6>
                            <br/>
                            {searchCategoriesWithProducts.map((category, index) => (
                                <div key={index}>
                                  <h6 className='titleCategoryContainer'><span className='titleCategory'  >{category.name}</span></h6>
                                  <div className="products-container">
                                    {category.productDTOList.map((product, index) => (
                                        <div key={index} className={`product ${product.image != null ? 'product-with-image' : ''}`}>
                                          {product.image != null ?
                                              <>
                                                <img src={product.image} alt="Imagen del producto"
                                                     className="img-fluid imgProduct"/>
                                                <div className='bodyWithImage'>
                                                  {product.brandName != null && product.brandName != "" &&
                                                      <div><p className='brand brandWithImage'>{product.brandName}</p></div>}
                                                  <p className='nameProd nameProdWithImage'>{product.name}</p>
                                                  <p className='descProd descProdWithImage'>{product.description}</p>
                                                  <div className='divPriceAndBotonera divPriceAndBotoneraWithImage'>

                                                    {/*ACA SE HACE EL CONTROL CON LA VARIABLE isPriceActive*/}
                                                    {(branchConfig?.priceActive) && <>
                                                      <p className='priceProd priceProdWithImage'>{formatPrice(product.price)}</p>
                                                      {(branchConfig?.status) &&
                                                          <>
                                                            <div className='divBotonera divBotoneraWithImage'>
                                                              <button className='btn'><SubtractAlt size={20}
                                                                                                   onClick={() => minusProdPedido(product.id)}/>
                                                              </button>
                                                              <p id='cantEnPedido cantEnPedidoWithImage'
                                                                 style={{margin: '0'}}>{contProd(product.id)}</p>
                                                              <button className='btn'><AddAlt size={20}
                                                                                              style={{marginLeft: '5%'}}
                                                                                              onClick={() => addProdPedido(product)}/>
                                                              </button>
                                                            </div>
                                                          </>
                                                      }
                                                    </>
                                                    }



                                                  </div>
                                                </div>
                                              </>
                                              :
                                              <>
                                                {product.brandName != null && product.brandName != "" &&
                                                    <div><p className='brand brandWithImage'>{product.brandName}</p></div>}
                                                <p className='nameProd'>{product.name}</p>
                                                {requiresFlavorSelection(product) && (
                                                  <div className="flavor-config-badge mb-1">
                                                    <small className="badge bg-warning text-dark">
                                                      🍨 {getFlavorConfigText(product)}
                                                    </small>
                                                  </div>
                                                )}
                                                <p className='descProd'>{product.description}</p>
                                                <div className='divPriceAndBotonera'>


                                                  {/*ACA SE HACE EL CONTROL CON LA VARIABLE isPriceActive*/}
                                                  {(branchConfig?.priceActive) && <>
                                                    <p className='priceProd'>{formatPrice(product.price)}</p>
                                                    {(branchConfig?.status) &&
                                                        <>
                                                          <div className='divBotonera'>
                                                            <button className='btn'><SubtractAlt size={20}
                                                                                                 onClick={() => minusProdPedido(product.id)}/>
                                                            </button>
                                                            <p id='cantEnPedido'
                                                               style={{margin: '0'}}>{contProd(product.id)}</p>
                                                            <button className='btn'><AddAlt size={20} style={{marginLeft: '5%'}}
                                                                                            onClick={() => addProdPedido(product)}/>
                                                            </button>
                                                          </div>
                                                        </>
                                                    }
                                                  </>
                                                  }


                                                </div>
                                              </>
                                          }
                                        </div>
                                    ))}
                                  </div>
                                  <br/>
                                </div>
                            ))}

                          </>
                      ) : (
                          <>
                            <h6 className='allProductsText '>{allProductsText}</h6>
                            <br/>
                            {categories.map((category, index) => (
                                <div key={index}>
                                  <h6 className='titleCategoryContainer'><span className='titleCategory'>{category.name}</span></h6>
                                  <div className='products-container'>
                                    {category.productDTOList.map((product, index) => (
                                        <div key={index} className={`product  ${product.image != null ? 'product-with-image' : ''}`}>
                                          {product.image != null ?
                                              <>
                                                <img src={product.image} alt="Imagen del producto"
                                                     className="img-fluid imgProduct"/>
                                                <div className='bodyWithImage'>
                                                  {product.brandName != null && product.brandName != "" &&
                                                      <div><p className='brand brandWithImage'>{product.brandName}</p></div>}
                                                  <p className='nameProd nameProdWithImage'>{product.name}</p>
                                                  {requiresFlavorSelection(product) && (
                                                    <div className="flavor-config-badge mb-1">
                                                      <small className="badge bg-warning text-dark">
                                                        🍨 {getFlavorConfigText(product)}
                                                      </small>
                                                    </div>
                                                  )}
                                                  <p className='descProd descProdWithImage'>{product.description}</p>
                                                  <div className='divPriceAndBotonera'>

                                                    {/*ACA SE HACE EL CONTROL CON LA VARIABLE isPriceActive*/}
                                                    {(branchConfig?.priceActive) && <>
                                                      <p className='priceProd'>{formatPrice(product.price)}</p>
                                                      {(branchConfig?.status) &&
                                                          <>
                                                            <div className='divBotonera'>
                                                              <button className='btn'><SubtractAlt size={20}
                                                                                                 onClick={() => minusProdPedido(product.id)}/>
                                                              </button>
                                                              <p id='cantEnPedido'
                                                                 style={{margin: '0'}}>{contProd(product.id)}</p>
                                                              <button className='btn'><AddAlt size={20} style={{marginLeft: '5%'}}
                                                                                              onClick={() => addProdPedido(product)}/>
                                                              </button>
                                                            </div>
                                                          </>
                                                      }
                                                    </>
                                                    }


                                                  </div>
                                                </div>
                                              </>
                                              :
                                              <>
                                                {product.brandName != null && product.brandName != "" &&
                                                    <div><p className='brand brandWithImage'>{product.brandName}</p></div>}
                                                <p className='nameProd'>{product.name}</p>
                                                {requiresFlavorSelection(product) && (
                                                  <div className="flavor-config-badge mb-1">
                                                    <small className="badge bg-warning text-dark">
                                                      🍨 {getFlavorConfigText(product)}
                                                    </small>
                                                  </div>
                                                )}
                                                <p className='descProd'>{product.description}</p>
                                                <div className='divPriceAndBotonera'>

                                                  {/*ACA SE HACE EL CONTROL CON LA VARIABLE isPriceActive*/}
                                                  {(branchConfig?.priceActive) && <>
                                                    <p className='priceProd'>{formatPrice(product.price)}</p>
                                                    {(branchConfig?.status) &&
                                                        <>
                                                          <div className='divBotonera'>
                                                            <button className='btn'><SubtractAlt size={20}
                                                                                                 onClick={() => minusProdPedido(product.id)}/>
                                                            </button>
                                                            <p id='cantEnPedido' style={{margin: '0'}}>{contProd(product.id)}</p>
                                                            <button className='btn'><AddAlt size={20} style={{marginLeft: '5%'}}
                                                                                            onClick={() => addProdPedido(product)}/>
                                                            </button>
                                                          </div>
                                                        </>
                                                    }
                                                  </>
                                                  }
                                                </div>
                                              </>
                                          }

                                        </div>
                                    ))}
                                  </div>
                                  <br/>
                                </div>
                            ))}

                          </>
                      )

                  ) : (
                      <>
                        <h6 className='titleCategoryContainer'><span className='titleCategory' >{nameCategorySelected}</span></h6>
                        <div className='products-container'>
                                                     {(searching) ? (
                               searchProducts.map((product, index) => (
                                   <div key={index} className={`product ${product.image != null ? 'product-with-image' : ''}`}>
                                     {product.image != null ?
                                         <>
                                           <img src={product.image} alt="Imagen del producto"
                                                className="img-fluid imgProduct"/>
                                           <div className='bodyWithImage'>
                                             {product.brandName != null && product.brandName != "" &&
                                                 <div><p className='brand brandWithImage'>{product.brandName}</p></div>}
                                             <p className='nameProd nameProdWithImage'>{product.name}</p>
                                             {requiresFlavorSelection(product) && (
                                               <div className="flavor-config-badge mb-1">
                                                 <small className="badge bg-warning text-dark">
                                                   🍨 {getFlavorConfigText(product)}
                                                 </small>
                                               </div>
                                             )}
                                             <p className='descProd descProdWithImage'>{product.description}</p>

                                            <div className='divPriceAndBotonera divPriceAndBotoneraWithImage'>

                                              {/*ACA SE HACE EL CONTROL CON LA VARIABLE isPriceActive*/}
                                              {(branchConfig?.priceActive) && <>
                                                <p className='priceProd priceProdWithImage'>{formatPrice(product.price)}</p>
                                                {(branchConfig?.status) &&
                                                    <>
                                                      <div className='divBotonera divBotoneraWithImage'>
                                                        <button className='btn'><SubtractAlt size={20}
                                                                                             onClick={() => minusProdPedido(product.id)}/>
                                                        </button>
                                                        <p id='cantEnPedido cantEnPedidoWithImage'
                                                           style={{margin: '0'}}>{contProd(product.id)}</p>
                                                        <button className='btn'><AddAlt size={20} style={{marginLeft: '5%'}}
                                                                                        onClick={() => addProdPedido(product)}/>
                                                        </button>
                                                      </div>
                                                    </>
                                                }
                                              </>
                                              }



                                            </div>
                                          </div>
                                        </>
                                        :
                                        <>
                                          {product.brandName != null && product.brandName != "" &&
                                              <div><p className='brand brandWithImage'>{product.brandName}</p></div>}
                                          <p className='nameProd'>{product.name}</p>
                                          {requiresFlavorSelection(product) && (
                                            <div className="flavor-config-badge mb-1">
                                              <small className="badge bg-warning text-dark">
                                                🍨 {getFlavorConfigText(product)}
                                              </small>
                                            </div>
                                          )}
                                          <p className='descProd'>{product.description}</p>

                                          <div className='divPriceAndBotonera'>

                                            {/*ACA SE HACE EL CONTROL CON LA VARIABLE isPriceActive*/}
                                            {(branchConfig?.priceActive) && <>
                                              <p className='priceProd'>{formatPrice(product.price)}</p>
                                              {(branchConfig?.status) &&
                                                  <>
                                                    <div className='divBotonera'>
                                                      <button className='btn'><SubtractAlt size={20}
                                                                                           onClick={() => minusProdPedido(product.id)}/>
                                                      </button>
                                                      <p id='cantEnPedido' style={{margin: '0'}}>{contProd(product.id)}</p>
                                                      <button className='btn'><AddAlt size={20} style={{marginLeft: '5%'}}
                                                                                      onClick={() => addProdPedido(product)}/>
                                                      </button>
                                                    </div>
                                                  </>
                                              }
                                            </>
                                            }

                                          </div>
                                        </>
                                    }

                                  </div>

                              ))
                          ) : (
                              productsForCategory.map((product, index) => (
                                  <div key={index} className={`product ${product.image != null ? 'product-with-image' : ''}`}>
                                    {product.image != null ?
                                        <>
                                          <img src={product.image} alt="Imagen del producto"
                                               className="img-fluid imgProduct"/>
                                          <div className='bodyWithImage'>
                                            {product.brandName != null && product.brandName != "" &&
                                                <div><p className='brand brandWithImage'>{product.brandName}</p></div>}
                                            <p className='nameProd nameProdWithImage'>{product.name}</p>
                                            {requiresFlavorSelection(product) && (
                                              <div className="flavor-config-badge mb-1">
                                                <small className="badge bg-warning text-dark">
                                                  🍨 {getFlavorConfigText(product)}
                                                </small>
                                              </div>
                                            )}
                                            <p className='descProd descProdWithImage'>{product.description}</p>

                                            <div className='divPriceAndBotonera divPriceAndBotoneraWithImage'>

                                              {/*ACA SE HACE EL CONTROL CON LA VARIABLE isPriceActive*/}
                                              {(branchConfig?.priceActive) && <>
                                                <p className='priceProd priceProdWithImage'>{formatPrice(product.price)}</p>
                                                {(branchConfig?.status) &&
                                                    <>
                                                      <div className='divBotonera divBotoneraWithImage'>
                                                        <button className='btn'><SubtractAlt size={20}
                                                                                             onClick={() => minusProdPedido(product.id)}/>
                                                        </button>
                                                        <p id='cantEnPedido cantEnPedidoWithImage'
                                                           style={{margin: '0'}}>{contProd(product.id)}</p>
                                                        <button className='btn'><AddAlt size={20} style={{marginLeft: '5%'}}
                                                                                        onClick={() => addProdPedido(product)}/>
                                                        </button>
                                                      </div>
                                                    </>
                                                }
                                              </>
                                              }


                                            </div>
                                          </div>
                                        </>
                                        :
                                        <>
                                          {product.brandName != null && product.brandName != "" &&
                                              <div><p className='brand brandWithImage'>{product.brandName}</p></div>}
                                          <p className='nameProd'>{product.name}</p>
                                          {requiresFlavorSelection(product) && (
                                            <div className="flavor-config-badge mb-1">
                                              <small className="badge bg-warning text-dark">
                                                🍨 {getFlavorConfigText(product)}
                                              </small>
                                            </div>
                                          )}
                                          <p className='descProd'>{product.description}</p>

                                          <div className='divPriceAndBotonera'>

                                            {/*ACA SE HACE EL CONTROL CON LA VARIABLE isPriceActive*/}
                                            {(branchConfig?.priceActive) && <>
                                              <p className='priceProd'>{formatPrice(product.price)}</p>
                                              {(branchConfig?.status) &&
                                                  <>
                                                    <div className='divBotonera'>
                                                      <button className='btn'><SubtractAlt size={20}
                                                                                           onClick={() => minusProdPedido(product.id)}/>
                                                      </button>
                                                      <p id='cantEnPedido' style={{margin: '0'}}>{contProd(product.id)}</p>
                                                                                                              <button className='btn'><AddAlt size={20} style={{marginLeft: '5%'}}
                                                                                       onClick={() => addProdPedido(product)}/>
                                                      </button>
                                                    </div>
                                                  </>
                                              }
                                            </>
                                            }

                                          </div>
                                        </>
                                    }

                                  </div>
                              )))
                          }
                        </div>
                      </>
                  )}
                </div>
              </div>

                {((getCartProducts().length > 0) && (branchConfig?.status)) && (
                    <button id='btnCarrito' data-bs-toggle="modal" data-bs-target="#modalProductsPedido"
                            className="round-button-pedido"
                            onClick={() => {
                              setDataProductsPedidoModal(getCartProducts())
                            }}>
                      <ShoppingCart size={30}/>
                    </button>
                )}

                <div className="modal fade modal-lg" id="modalProductsPedido" data-bs-backdrop="static"
                     data-bs-keyboard="false"
                     tabIndex="-1" aria-labelledby="modalProductsPedidoLabel" aria-hidden="true">
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header modalPedido">
                        <h1 className="modal-title fs-5 titleModalPedido" id="modalProductsPedidoLabel"
                            style={{marginTop: '4%', marginLeft: '4%'}}>Tu pedido</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                id="btnCloseCarrito"></button>
                      </div>
                      <div className="modal-body modalPedido">

                        {dataProductsPedidoModal.map((product, index) => (
                            <div key={index} className='productCarrito'>
                              {product.brandName != null && product.brandName != "" &&
                                  <div><p className='brand brandWithImage'>{product.brandName}</p></div>}
                              <p className='nameProdPedido'>{product.name}</p>

                              <div className='divPriceAndBotoneraPedido'>
                                <p className='priceProdPedido'>{formatPrice(product.price)}</p>
                                {branchConfig?.status &&
                                    <>
                                      <div className='divBotonera'>
                                        <button className='btn' style={{color: 'red'}}><TrashCan size={20}
                                                                                                 onClick={() => deleteProductPedido(product.id)}/>
                                        </button>
                                        <button className='btn'><SubtractAlt size={20}
                                                                             onClick={() => minusProdPedido(product.id)}/>
                                        </button>
                                        <p id='cantEnPedido' style={{margin: '0'}}>{contProd(product.id)}</p>
                                        <button className='btn'><AddAlt size={20} style={{marginLeft: '5%'}}
                                                                        onClick={() => increaseProductQuantity(product)}/>
                                        </button>
                                      </div>
                                    </>}
                              </div>
                              <p className='priceProdPedidoSubtotal'>Subtotal:
                                {formatPrice((product.price * product.cant).toFixed(2))}</p>
                            </div>
                        ))}
                        <br/>
                        <p className='priceProdTotalPedido'>TOTAL:
                          {formatPrice(calcularTotal(dataProductsPedidoModal).toFixed(2))}</p>
                        <br/>
                        <div style={{marginLeft: '5%'}}>
                          <label htmlFor="observations" className="col-form-label">Obvservaciones del pedido:</label>
                          <textarea rows="3" className="form-control observationsPedido" id="observationsPedido"
                                    value={observationsPedido} onChange={(e) => {
                            setObservationsPedido(e.target.value);
                          }}/>
                        </div>
                      </div>
                      <div className="modal-footer modalPedido">
                        <button id="btnCloseModalAdd" type="button" className="btn btn-dark" data-bs-dismiss="modal"
                                onClick={() => cleanPedidoBorrador()}>Borrar pedido
                        </button>
                                                 <button id="btnSendPedidoForWhatsapp" type="button" className="btn"
                                 data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#modalDataForPedido"
                                 style={{backgroundColor: colorshop, color: '#ffffff'}}
                                 disabled={dataProductsPedidoModal.length == 0 ? true : false}>Siguiente
                         </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal fade modal-lg" id="modalDataForPedido" data-bs-backdrop="static"
                     data-bs-keyboard="false"
                     tabIndex="-1" aria-labelledby="modalDataForPedidoLabel" aria-hidden="true">
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header modalPedido">
                        <h1 className="modal-title fs-5 titleModalDatosPedido" id="modalDataForPedidoLabel">Datos
                          para
                          finalizar tu pedido</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"
                                data-bs-toggle="modal" data-bs-target="#modalProductsPedido"
                                onClick={() => cleanErrorSendPedido()}></button>
                        <button id="btnCloseModalPersona" hidden={true} type="button" data-bs-dismiss="modal"
                                aria-label="Close" onClick={() => cleanErrorSendPedido()}></button>
                      </div>
                      <div className="modal-body modalPedido">

                        <label htmlFor="nameAndSurname" className="col-form-label">Nombre y apellido:</label>
                        <input type="text" className="form-control nameAndSuername" id="nameAndSurname"
                               value={nameAndSuername} onChange={(e) => {
                          setNameAndSuername(e.target.value);
                          cleanErrorField('nameAndSurname', 'errorNameAndSurname');
                        }}
                        />
                        <div className='errorNameAndSurname' id='errorNameAndSurname'>Campo obligatorio</div>

                        <label htmlFor="isDelivery" className="col-form-label">Envío a domicilio:</label>
                        {branchConfig && isDeliveryActive(branchConfig) ? (
                            <>
                              <br/>
                              <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="isDeliveryTrue"
                                    name="isDelivery"
                                    value="true"
                                    checked={isDelivery === true}
                                    onChange={() => setIsDelivery(true)}
                                />
                                <label className="form-check-label" htmlFor="isDeliveryTrue">
                                  Sí
                                </label>
                              </div>
                              <br/>
                              <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="isDeliveryFalse"
                                    name="isDelivery"
                                    value="false"
                                    checked={isDelivery === false}
                                    onChange={() => {
                                      setIsDelivery(false);
                                      setStreetAddress('');
                                      setNumberAddress('');
                                      setLocalidadDirection('');
                                      setFloorAddress('');
                                      setDeptoAddress('');
                                      setObservationsAddress('');
                                    }}
                                />
                                <label className="form-check-label" htmlFor="isDeliveryFalse">
                                  No
                                </label>
                              </div>
                            </>
                        ) : (
                            <>
                              <p style={{color: '#CB3234'}}>Por el momento no realizamos envíos, ¡retiralo en nuestro
                                local!</p>
                              <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="isDeliveryTrue"
                                    name="isDelivery"
                                    value="false"
                                    disabled={true}
                                />
                                <label className="form-check-label" htmlFor="isDeliveryTrue">
                                  Sí
                                </label>
                              </div>
                              <br/>
                              <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="isDeliveryFalse"
                                    name="isDelivery"
                                    value="true"
                                    disabled={true}
                                />
                                <label className="form-check-label" htmlFor="isDeliveryFalse">
                                  No
                                </label>
                              </div>
                            </>
                        )}


                        {isDelivery && (
                            <>
                              <br/>
                              <p style={{color: "#959595"}}>
                                Valor del envío:{" "}
                                {googleLocalizationFeature
                                    ? shippingPrice !== 0.0
                                        ? formatPrice(shippingPrice)
                                        : "Calculando..."
                                    : formatPrice(branchConfig?.deliveryCommon?.priceBase || 0)}
                              </p>

                              <label htmlFor="addressPedido" className="col-form-label">Dirección de entrega:</label>
                              <br/>

                              {/* Checkbox para Envío a dirección rural */}
                              {ruralSettingsFeatures?.status && branchConfig?.ruralSettings && (
                                  <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="isRuralDelivery"
                                        name="isRuralDelivery"
                                        checked={isRuralDelivery}
                                        onChange={(e) => toggleRuralDelivery(e.target.checked)}
                                    />
                                    <label className="form-check-label" style={{marginTop: '0.7em'}}
                                           htmlFor="isRuralDelivery">
                                      Envío a dirección rural
                                    </label>
                                  </div>
                              )}

                              <div className="row">
                                <div className="col-8">
                                  <label htmlFor="streetAddress" className="col-form-label">Calle:</label>
                                  <input
                                      type="text"
                                      className="form-control streetAddress"
                                      id="streetAddress"
                                      value={streetAddress}
                                      onChange={(e) => {
                                        setStreetAddress(e.target.value);
                                        checkAddressChange();
                                        cleanErrorField('streetAddress', 'errorStreetAddress');
                                      }}
                                      disabled={!isDeliveryActive(branchConfig) || isRuralDelivery}
                                  />
                                  <div className="errorStreetAddress" id="errorStreetAddress">Campo obligatorio</div>
                                </div>

                                <div className="col">
                                  <label htmlFor="numberAddress" className="col-form-label">Número:</label>
                                  <input
                                      type="number"
                                      className="form-control numberAddress"
                                      id="numberAddress"
                                      value={numberAddress}
                                      onChange={(e) => {
                                        setNumberAddress(e.target.value);
                                        checkAddressChange();
                                        cleanErrorField('numberAddress', 'errorNumberAddress');
                                      }}
                                      disabled={!isDeliveryActive(branchConfig) || isRuralDelivery}
                                  />
                                  <div className="errorNumberAddress" id="errorNumberAddress">Campo obligatorio</div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-8">
                                  <label htmlFor="localidadDirection" className="col-form-label">Localidad:</label>
                                  <input
                                      type="text"
                                      className="form-control localidadDirection"
                                      id="localidadDirection"
                                      value={localidadDirection}
                                      onChange={(e) => {
                                        setLocalidadDirection(e.target.value);
                                        checkAddressChange();
                                        cleanErrorField('localidadDirection', 'errorLocalidadDirection');
                                      }}
                                      disabled={!isDeliveryActive(branchConfig) || isRuralDelivery}
                                  />
                                  <div className="errorLocalidadDirection" id="errorLocalidadDirection">Campo
                                    obligatorio
                                  </div>
                                </div>

                                {branchConfig?.verifyAddress && (
                                    <div className="col">
                                      <label htmlFor="validarDireccion" className="col-form-label"></label>
                                      <br/><br/>
                                      <button
                                          type="button"
                                          className="btn"
                                          style={{backgroundColor: '#007bff', color: '#ffffff'}}
                                          onClick={() => validateAddress()}
                                          disabled={isRuralDelivery} // Bloquea si es rural
                                      >
                                        Validar Dirección
                                      </button>
                                    </div>
                                )}
                              </div>

                              <div className="row">
                                <div className="col">
                                  <label htmlFor="piso" className="col-form-label">Piso:</label>
                                  <input
                                      type="number"
                                      className="form-control piso"
                                      id="piso"
                                      value={!isDeliveryActive(branchConfig) ? "" : floorAddress}
                                      onChange={(e) => setFloorAddress(e.target.value)}
                                      disabled={!isDeliveryActive(branchConfig) || isRuralDelivery}
                                  />
                                </div>

                                <div className="col">
                                  <label htmlFor="depto" className="col-form-label">Depto:</label>
                                  <input
                                      type="text"
                                      className="form-control depto"
                                      id="depto"
                                      value={!isDeliveryActive(branchConfig) ? "" : deptoAddress}
                                      onChange={(e) => setDeptoAddress(e.target.value)}
                                      disabled={!isDeliveryActive(branchConfig) || isRuralDelivery}
                                  />
                                </div>
                              </div>
                              <br/>

                              <label htmlFor="observations" className="col-form-label">Indicacion adicional del
                                destino:</label>
                              <textarea placeholder='Casa con rejas negras, sin timbre' rows="3"
                                        className="form-control observations" id="observations"
                                        value={!isDeliveryActive(branchConfig) ? "" : observationsAddress}
                                        onChange={(e) => {
                                          setObservationsAddress(e.target.value);
                                        }} disabled={!isDeliveryActive(branchConfig)}/>
                            </>


                        )}
                      </div>

                      <div className="modal-footer modalPedido">
                        <button id="btnCloseModalSendPedido" type="button" className="btn btn-secondary"
                                data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#modalProductsPedido"
                                onClick={() => cleanErrorSendPedido()}>Volver
                        </button>
                                                 <button type="button" className="btn"
                                 style={{backgroundColor: colorshop, color: '#ffffff'}}
                                 onClick={() => sendOrderForWhatsapp()}>Finalizar pedido
                         </button>
                      </div>
                    </div>
                  </div>
                </div>



                {/* Footer solo visible si NO está el selector de sucursal */}
                {!showBranchSelector && (
                  <div className='footer' style={{backgroundColor: colorshop}}>
                    <img src={iconoFooter} alt="Icono"/>
                  </div>
                )}

              </div>
              )}
              
              {/* Modal de selección de gustos */}
              <FlavorSelectionModal
                  show={showFlavorModal}
                  onHide={() => setShowFlavorModal(false)}
                  product={selectedProductForFlavors}
                  onConfirm={handleFlavorConfirm}
                  maxFlavors={selectedProductForFlavors ? getMaxFlavors(selectedProductForFlavors) : 1}
                  shopBranchId={selectedBranch?.id}
                  shopColor={colorshop}
              />
            </div>
        );


        }